export default __webpack_public_path__ + "static/media/15.05c3eb00.png";